import SpzLogo from "@/assets/logo-spz.svg";
import { Typography } from "@spz/ui/components/typography";
import { useTranslation } from "react-i18next";
import { SMALL_SCREEN_BREAKPOINT } from "../hooks/use-screen-size";

const SmallScreenMessage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="h-screen">
      <div className="flex items-center justify-center h-full bg-gray-50 rounded-md overflow-auto">
        <div className="flex flex-col w-full max-w-[534px] mx-6 gap-6">
          <div>
            <img src={SpzLogo} alt="SpzLogo" className="max-w-[170px]" />
          </div>
          <div className="gap-2">
            <Typography variant="h3">{t("small_screen")}</Typography>

            <Typography
              className="text-gray-700 text-subtitle"
              trans="small_screen_description"
              transParams={{ breakpoint: SMALL_SCREEN_BREAKPOINT }}
            />
          </div>
        </div>
      </div>{" "}
    </div>
  );
};

export default SmallScreenMessage;
